.viewer {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.buttonContainer1 {
  z-index: 100;
  position: absolute;
  top: 10px;
  left: 90px;
  display: flex;
  gap: 10px;
}

.buttonContainer2 {
  z-index: 100;
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.buttonContainer1,
.buttonContainer2,
.librarySidebar {
  pointer-events: none;
}

.buttonContainer1 > *,
.buttonContainer2 > *,
.librarySidebar > * {
  pointer-events: auto;
}

.buttonContainer1 button,
.buttonContainer2 button,
.buttonRowText {
  padding: 6px;
  font-size: 90%;
}

.librarySidebar {
  z-index: 100;
  position: absolute;
  top: 60px;
  left: 0;
  padding: 10px;
  width: 370px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100% - 60px - 256px - 10px);
}

.librarySidebar h3 {
  margin-bottom: 5px;
}

.librarySidebarCheckbox,
.librarySidebarScrollableSection {
  background: white;
  border: 1px solid black;
}

.librarySidebarScrollableSection {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.librarySidebarCheckbox {
  padding: 5px;
}

.libraryList h3 {
  margin: 0;
}

.libraryList ul {
  list-style-type: none;
  margin: 10px 0;
  padding: 0;
}

.libraryList li {
  margin: 0;
  padding: 2px 4px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
}

.libraryList li:hover {
  background: #f6f6f6;
}

.libraryListButton {
  margin-left: 5px;
  outline: none;
  color: #000;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 0 4px;
  margin: -2px 2px;
  background-color: transparent;

  &:hover:not(:disabled) {
    color: #07a;
  }

  &:focus {
    outline: 1px dotted #000;
    outline-offset: -5px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
}

.previewCanvasWithControls {
  position: relative;
  font-size: 0;
}

.previewCanvasControls {
  font-size: 10px;
  z-index: 150;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 6px;
  background: #cccccc;
}

.hatchMaterialPreview,
.thumbnailPreview {
  border: 1px solid #000;
}

.uiButtonColorCodeParent {
  position: relative;
}

.uiButtonColorCode {
  display: block;
  width: 100%;
  height: 5px;
  position: absolute;
  left: 0;
  top: 0;
}

.warning {
  background: rgba(255, 160, 80, 0.6);
}
